import { Box, Stack, Text, Button, Tooltip } from '@chakra-ui/react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import QuizPengetahuan from './Quiz';
import AssesmentPengetahuan from './Assesment';
import Kuisioner from './Kuisioner';
import { parseISO, isAfter, addMinutes } from 'date-fns';

const DaftarTugas = () => {
  const { pengetahuanItem, loadingChangeStatusPengetahuan } =
    usePengetahuanDetailContext().state;
  const { handleChangeStatusPengetahuan } = usePengetahuanDetailContext();

  const pengetahuanId = window.location.pathname.split('/', 4)[3];

  const endDate =
    pengetahuanItem?.jadwal_selesai &&
    parseISO(pengetahuanItem?.jadwal_selesai.replace(' ', 'T'));

  const fiveMinutesAfterEnd = endDate && addMinutes(endDate, 5);
  const now = new Date();

  const isReadyToEnd = isAfter(now, fiveMinutesAfterEnd as Date);

  const isFinishedAssessment = pengetahuanItem?.has_assessment
    ? !!pengetahuanItem?.file_peserta
    : true;

  const noQuizAndAssesment =
    !pengetahuanItem?.has_assessment && !pengetahuanItem?.paket_soal_id;

  const shouldDisableFinishButton = () => {
    const isSynchronizedAndNotReady =
      pengetahuanItem?.jenis_pengetahuan === 'synchronized' && !isReadyToEnd;

    const hasPendingQuiz =
      Boolean(
        pengetahuanItem?.pengetahuan_materi_saya?.t_pengetahuan_paket_soal_id
      ) &&
      pengetahuanItem?.pengetahuan_materi_saya?.t_pengetahuan_paket_soal
        ?.status_pengerjaan !== 'selesai dikerjakan';

    const isAssessmentNotFinished = !isFinishedAssessment;

    const isVideoNotCompleted =
      !pengetahuanItem?.has_completed_video &&
      pengetahuanItem?.status_pengerjaan === null &&
      !noQuizAndAssesment &&
      pengetahuanItem?.pengetahuan_materi_saya?.category === 'video';

    const isVideoWithNoQuizAndAssessment =
      !pengetahuanItem?.has_completed_video &&
      pengetahuanItem?.pengetahuan_materi_saya?.category === 'video' &&
      noQuizAndAssesment;

    return (
      isSynchronizedAndNotReady ||
      hasPendingQuiz ||
      isAssessmentNotFinished ||
      isVideoNotCompleted ||
      isVideoWithNoQuizAndAssessment
    );
  };

  return (
    <Box
      w="full"
      bg="white"
      rounded="lg"
      shadow="sm"
      border="1px"
      borderColor="gray.200"
    >
      <Box p={6} borderBottom="1px" borderColor="gray.200">
        <Text fontSize="lg" fontWeight="semibold" color="gray.800">
          Daftar Tugas Anda
        </Text>
      </Box>

      <Stack p={6} spacing={4}>
        <QuizPengetahuan />
        <AssesmentPengetahuan />
        <Kuisioner />
      </Stack>

      {pengetahuanItem?.status_pengetahuan === 'mengikuti' && (
        <Box p={6} borderTop="1px" borderColor="gray.200">
          <Tooltip
            label='Anda dapat mengklik tombol "Selesai Pengetahuan" lima menit setelah Video Live/Zoom berakhir'
            placement="top"
            gutter={2}
            maxW="none"
            whiteSpace="nowrap"
            hasArrow
            isDisabled={
              pengetahuanItem?.jenis_pengetahuan === 'asynchronized' ||
              isReadyToEnd
            }
          >
            <Box>
              <Button
                colorScheme={shouldDisableFinishButton() ? 'gray' : 'green'}
                size="lg"
                w="full"
                onClick={() =>
                  handleChangeStatusPengetahuan(pengetahuanId, 'selesai')
                }
                isLoading={loadingChangeStatusPengetahuan}
                isDisabled={shouldDisableFinishButton()}
              >
                Selesaikan Klinik
              </Button>
            </Box>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default DaftarTugas;